export default {
  namespaced: true,
  bulk_edit: {
    title: "Mudanças em massa",
    modal_title: "Edição em massa",
    activate_mode: "Ativar seleção múltipla",
    multi_select: "Seleção múltipla",
    select_all: "Selecionar tudo",
    exit: "Sair da seleção",
    edit_selected: "Editar ({count})",
    info_message: "{count} registros selecionados serão modificados.",
    only_filled_fields: "Apenas os campos com um valor selecionado serão atualizados. Os campos vazios não serão modificados.",
    select_placeholder: "Sem mudanças",
    select_dependency_placeholder: "Selecione {field} primeiro",
    apply_changes: "Aplicar mudanças ({count})",
    success: "Atualização em massa bem-sucedida",
    confirm_title: "Confirmar mudanças em massa",
    confirm_body: "Tem certeza de que deseja aplicar as alterações a {count} registros?",
    batch_progress_title: "Atualização em massa em andamento",
    batch_progress_text: "Processando {count} registros...",
    batch_cancelled: "A atualização em massa foi cancelada",
    batch_status_error: "Não foi possível consultar o status da atualização em massa",
    batch_in_progress: "Já existe uma atualização em massa em andamento, aguarde a conclusão",
    enable_field: "modificar este campo",
    cameras_selected: "{count} dispositivos selecionados",
    assign_selected: "Dispositivos a atribuir",
    assign_count: "{count} para atribuir",
    device_id: "ID Câmera Proxy: {id}",
    assign_all: "Atribuir todos",
    assign_all_warning: "TODOS os dispositivos que correspondam aos filtros serão atribuídos aos usuários selecionados.",
    unassign_all: "Desatribuir todos",
    unassign_all_warning: "TODOS os dispositivos que correspondam aos filtros serão removidos dos usuários selecionados.",
    replace_lists_hint: "As listas selecionadas (tenants, tipos de alarme, módulos) substituirão completamente as atribuídas a cada usuário.",
    additional_info_hint: "Esta lista substituirá completamente as informações adicionais de cada registro selecionado.",
    emergency_contact_hint: "Esta lista substituirá completamente os contatos de emergência de cada registro selecionado.",
  },
};
